module.exports = __webpack_public_path__ + "static/cleaning-0840f77738e5b1662ffa878c6e7455a3.png";